export default __webpack_public_path__ + "static/media/ASPA - Brochure Corporativo 2021.aca9ef21.pdf";